import { FlowListItem } from '../../flow/serverApi/types/Flow';
import { Request } from '../../httpClient/serverApi/requests/Request';
import { IConnectedView, IMetric } from '../../metrics/serverApi/types/IMetric';
import { IPublishedConnection } from '../../publishedConnection/serverApi/types/IPublishedConnection';
import { IGetItemsParams } from '../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../ts/ServerApi/types/IGetItemsResult';
import { IRecent } from '../../ts/ServerApi/types/IRecent';
import { IViewUsageInfo } from '../../ts/ServerApi/types/IUsageInfo';
import { IUser } from '../../ts/ServerApi/types/IUser';
import { IView } from '../../ts/ServerApi/types/IView';
import { INamedItem, ITypedItem } from '../../ts/ServerApi/types/resourceParts';
import { IWorkbook } from '../../workbook/ServerApi/types/IWorkbook';

export interface IGetDetailedRecentsResult extends IGetItemsResult {
  connectedViews?: IConnectedView[];
  metrics?: IMetric[];
  metricFavorites?: string[];
  publishedConnections?: IPublishedConnection[];
  publishedConnectionFavorites?: string[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  recents?: IRecent[];
  users?: IUser[];
  views?: IView[];
  workbooks?: IWorkbook[];
  viewMaxStats?: IViewUsageInfo;
  viewFavorites?: string[];
  flows?: FlowListItem[];
  flowFavorites?: string[];
}

export class GetDetailedRecentsRequest extends Request<IGetItemsParams, IGetDetailedRecentsResult> {
  constructor(params: IGetItemsParams) {
    super('getDetailedRecents', params);
  }
}
